/**
 * What a maintenance item is CALLED — its category in its building, narrowed by its location:
 * `Air-conditioning — Main Building · Roof deck`.
 *
 * An item has no name of its own (product call, 12 Oct 2026); a typed one was a second, drifting
 * copy of these facts. ONE helper, so the register, the calendars and the profile cannot spell
 * it three ways. An item registered before the building became required has none, and its title
 * is the category alone rather than a dangling separator.
 */
export function maintenanceItemTitle(item: {
  categoryName: string;
  buildingName: string | null;
  location: string | null;
}): string {
  const where = [item.buildingName, item.location].filter((part): part is string => part != null && part !== '');

  if (where.length === 0) return item.categoryName;

  return `${item.categoryName} — ${where.join(' · ')}`;
}
